export type Point = { x: number; y: number };

export type Playfield = {
  width: number;
  height: number;
  /** Inset so ship stays fully visible */
  margin: number;
};

/**
 * One-thumb steer: pointer position maps to ship target, clamped to playfield.
 */
export class ThumbSteer {
  private active = false;
  private pointerId: number | null = null;
  target: Point = { x: 0, y: 0 };

  constructor(private field: Playfield) {
    this.center();
  }

  setField(field: Playfield): void {
    this.field = field;
    this.target = clampPoint(this.target, field);
  }

  center(): void {
    this.target = {
      x: this.field.width / 2,
      y: this.field.height * 0.72,
    };
  }

  onPointerDown(id: number, x: number, y: number): void {
    if (this.active) return;
    this.active = true;
    this.pointerId = id;
    this.target = clampPoint({ x, y }, this.field);
  }

  onPointerMove(id: number, x: number, y: number): void {
    if (!this.active || this.pointerId !== id) return;
    this.target = clampPoint({ x, y }, this.field);
  }

  onPointerUp(id: number): void {
    if (this.pointerId !== id) return;
    this.active = false;
    this.pointerId = null;
  }

  /** Ease current toward target; returns new position */
  step(current: Point, dt: number, follow = 12): Point {
    const t = 1 - Math.exp(-follow * dt);
    return {
      x: current.x + (this.target.x - current.x) * t,
      y: current.y + (this.target.y - current.y) * t,
    };
  }
}

export function clampPoint(p: Point, field: Playfield): Point {
  const m = field.margin;
  return {
    x: Math.min(field.width - m, Math.max(m, p.x)),
    y: Math.min(field.height - m, Math.max(m, p.y)),
  };
}
